import React from "react";
import styles from "./LoadingWaves.module.css";

interface LoadingWavesProps {
  label?: string;
}

const LoadingWaves: React.FC<LoadingWavesProps> = ({ label }) => {
  return (
    <div className={styles.loader}>
      <div className={styles.waves}>
        {[0, 1, 2, 3, 4].map((i) => {
          const count = 18 + Math.floor(Math.random() * 16);
          const tallChance = 0.25;
          // Wider, cumulative staggering using negative delays so motion is continuous from the start
          const baseSeg = 600; // base spacing between rows
          const jitter = Math.floor(Math.random() * 250); // small variance per row
          const rowDelay = -(i * baseSeg + jitter); // negative delay starts rows mid-animation
          const rowDuration = 3600 + Math.floor(Math.random() * 2000); // 3.6-5.6s
          return (
            <div
              key={i}
              className={styles.row}
              style={{
                animationDelay: `${rowDelay}ms`,
                animationDuration: `${rowDuration}ms`,
              }}
            >
              {Array.from({ length: count }).map((_, j) => {
                const isTall = i < 4 && Math.random() < tallChance;
                const size = 4 + Math.floor(Math.random() * 6);
                const duration = 600 + Math.floor(Math.random() * 800);
                const delay = Math.floor(Math.random() * 200);
                return (
                  <div
                    key={j}
                    className={`${styles.dot} ${isTall ? styles.dotTall : ""} ${
                      styles.dotPulse
                    }`}
                    style={{
                      width: size,
                      height: isTall ? undefined : size,
                      animationDuration: `${duration}ms`,
                      animationDelay: `${delay}ms`,
                    }}
                  />
                );
              })}
            </div>
          );
        })}
      </div>
      {label && (
        <div
          style={{
            color: "#e5e7eb",
            fontSize: 15,
            marginTop: 8,
            textAlign: "center",
          }}
        >
          {label}
        </div>
      )}
    </div>
  );
};

export default LoadingWaves;
